/* global $ */
import { settingsToQueryString } from '../../app/bento-components/video-list/video-utils';

export function getVideos(API, settings, showLoading = () => {}) {
    showLoading();

    // the API takes the countries' codes ("US,MX"); the saved settings hold the selected
    // options ([{ label, value }]), which jQuery would send as country[0][label]=...
    // No regions (cleared in the settings) sends no country, as before
    const { selectedRegions } = settings;
    const country = Array.isArray(selectedRegions)
        ? selectedRegions.map(({ value }) => value).join(',')
        : selectedRegions;
    const data = country ? { country } : null;

    return $.ajax({
        method: 'GET',
        url: `${API.MEDIA_MANAGER_ASSETS}${settingsToQueryString(settings)}`,
        data,
        type: 'json',
        cache: false
    });
}
